import React, { useState } from 'react'
import {
  Table,
  Panel,
  IconButton,
  Icon,
  Grid,
  Row,
  Col,
  Checkbox,
  Message,
  ControlLabel,
  Input,
  Button,
  SelectPicker,
  Badge,
} from 'rsuite'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import TooltipButton from '../../components/buttons/TooltipButton'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { budgetFormat } from '../../utils/formatterUtil'
import './styles.less'
import AppContext from '../../context/AppContext'

export default function ProjectDataTable({
  schema,
  resizeProjectTypeField,
  subName,
  single,
  onSingleSubmit = () => {},
  multi,
  onMultiSubmit,
  enableView,
  onView,
  onRemove,
  onReload,
  pagination,
  lengthMenu,
  loading,
  searchEnable,
  reviewTypeSearch,
  departmentSearch,
  projectTypeSearch,
  hideProjectType,
  submit,
  onSubmit = () => {},
  isSubmitLoading,
  defaultDisplay = 5,
  defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ],
  setting = false,
  ...props
}) {
  // const { isProjectReviewType } = props
  const contextValue = React.useContext(AppContext)
  const { Column, HeaderCell, Cell } = Table
  const [selectList, setSelectList] = useState([])
  const [isError, setIsError] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [deleteObj, setDeleteObj] = useState({})
  const [inputValueCode, setInputValueCode] = useState('')
  const [inputValueName, setInputValueName] = useState('')
  const [inputValueReviewType, setInputValueReviewType] = useState('')
  const [statusBox, setStatusBox] = useState()
  const [projectType, setProjectType] = useState('')
  const [department, setDepartment] = useState('')

  const [displayLength, setDisplayLength] = useState(defaultDisplay)
  const [page, setPage] = useState(1)

  const defaultPage = 1
  const styleHeaderCell = { whiteSpace: 'normal', wordBreak: 'break-word' }
  const fs = localStorage.getItem('fontSize')

  const getIcon = (key) => {
    if (key == 1) {
      return 'file-o'
    } else if (key == 2) {
      return 'copy-o'
    } else if (key == 3) {
      return 'building2'
    }
  }

  const handleChangeLength = (dataKey) => {
    setPage(1)
    setDisplayLength(dataKey)
    if (typeof onReload === 'function') {
      onReload(
        dataKey,
        1,
        inputValueCode,
        inputValueName,
        inputValueReviewType,
        statusBox,
        department,
        projectType
      )
    }
  }
  const handleChangePage = (dataKey) => {
    setPage(dataKey)
    if (typeof onReload === 'function') {
      onReload(
        displayLength,
        dataKey,
        inputValueCode,
        inputValueName,
        inputValueReviewType,
        statusBox,
        department,
        projectType
      )
    }
  }

  const handleSearchProject = () => {
    setPage(1)
    onReload(
      5,
      1,
      inputValueCode,
      inputValueName,
      inputValueReviewType,
      statusBox,
      department,
      projectType
    )
  }

  const handleSearchByStatusBox = (statusBox) => {
    setPage(1)
    onReload(
      5,
      1,
      inputValueCode,
      inputValueName,
      inputValueReviewType,
      statusBox,
      department,
      projectType
    )
  }

  const handleCancelSearchProject = () => {
    setInputValueCode('')
    setInputValueName('')
    setInputValueReviewType('')
    setStatusBox('')
    setProjectType('')
    setDepartment('')
    onReload(5, 1)
    setPage(1)
  }

  const IconLabel = ({ data }) => {
    return (
      <Row /*style={{ marginTop: '5%' }}*/>
        <Col
          lg={8}
          md={8}
          sm={8}
          xs={8}
          style={{
            // width: 32,
            // height: 32,
            width: '2.5rem',
            height: '2.5rem',
            // background: '#f5f5f5',
            background: '#f0f0f0',
            borderRadius: 20,
            marginTop: 2,
            overflow: 'hidden',
            display: 'inline-block',
            textAlign: 'center',
          }}
        >
          <Icon icon={data.icon} size={'lg'} style={{ marginTop: 10 }} />
        </Col>
        <Col lg={16} md={16} sm={16} xs={16} style={{ marginTop: 10 }}>
          {data.label}
        </Col>
      </Row>
    )
  }

  const IconFindByName = ({ data }) => {
    return (
      <Row /*style={{ marginTop: '5%' }}*/>
        <Col
          lg={8}
          md={8}
          sm={8}
          xs={8}
          style={{
            // width: 32,
            // height: 32,
            width: '2.5rem',
            height: '2.5rem',
            background: '#f0f0f0',
            marginTop: 2,
            overflow: 'hidden',
            display: 'inline-block',
            textAlign: 'center',
          }}
        >
          <Icon icon={getIcon(data.value)} size={'lg'} style={{ marginTop: 10 }} />
        </Col>
        <Col lg={16} md={16} sm={16} xs={16} style={{ marginTop: 10 }}>
          {data.name}
        </Col>
      </Row>
    )
  }

  const IconFindByLabel = ({ data }) => {
    return (
      <Row /*style={{ marginTop: '5%' }}*/>
        <Col
          lg={8}
          md={8}
          sm={8}
          xs={8}
          style={{
            // width: 32,
            // height: 32,
            width: '2.5rem',
            height: '2.5rem',
            // background: '#f5f5f5',
            background: contextValue.theme[0] == 'dark' ? '#515151' : '#f0f0f0',
            borderRadius: 20,
            marginTop: 2,
            overflow: 'hidden',
            display: 'inline-block',
            textAlign: 'center',
          }}
        >
          <Icon icon={getIcon(data.label)} size={'lg'} style={{ marginTop: 10 }} />
        </Col>
        <Col lg={16} md={16} sm={16} xs={16} style={{ marginTop: 10 }}>
          {data.value}
        </Col>
      </Row>
    )
  }

  const ImageCell = ({ rowData, dataKey, ...props }) => (
    <Cell {...props} /*style={{ padding: 0 }}*/>
      <Grid fluid>
        {rowData[dataKey]?.isHaveIcon ? (
          <IconLabel data={rowData[dataKey]} />
        ) : rowData[dataKey]?.name ? (
          <IconFindByName data={rowData[dataKey]} />
        ) : (
          <IconFindByLabel data={rowData[dataKey]} />
        )}
      </Grid>
    </Cell>
  )

  const SubnameCell = ({ rowData, dataKey, ...props }) => {
    return (
      <Cell {...props}>
        <Grid fluid>
          <Row>
            <Col lg={24} md={24} sm={24} xs={24}>
              {rowData[dataKey].name || rowData[dataKey]}
            </Col>
            <Col lg={24} md={24} sm={24} xs={24} style={{ fontSize: 12, color: '#ff9800' }}>
              {rowData[dataKey].statusName && (
                <>
                  <Icon icon="exclamation-circle2" size="lg" />
                  &nbsp;&nbsp;
                  {rowData[dataKey].statusName}
                </>
              )}
            </Col>
          </Row>
        </Grid>
      </Cell>
    )
  }

  const multiButton = () => {
    return (
      multi?.enable && (
        <Row style={{ marginTop: -10 }}>
          {isError && (
            <Row style={{ marginTop: 10 }}>
              <Message showIcon type="error" description="กรุณาเลือกอย่างน้อย 1 โครงการ"></Message>
            </Row>
          )}
          {multi.errorMessage && (
            <Row style={{ marginTop: 10 }}>
              <Message showIcon type="error" description={multi.errorMessage}></Message>
            </Row>
          )}
          <IconButton
            appearance="ghost"
            icon={<Icon icon={multi.icon || 'filter'} className="bt-gost-icon-radius" />}
            style={{ float: 'right', marginBottom: 20, marginTop: 10 }}
            onClick={() => {
              if (!multi?.disableSelect && selectList && selectList.length < 1) {
                setIsError(true)
              } else {
                onMultiSubmit(selectList)
                setSelectList([])
              }
            }}
            disabled={setting}
          >
            {multi?.buttonText || ''}
          </IconButton>
        </Row>
      )
    )
  }

  const SubmitButton = ({ data }) => {
    return (
      <>
        {data?.enable && (
          <Row style={{ marginTop: -10 }}>
            {/* {isError && (
            <Row style={{ marginTop: 10 }}>
              <Message showIcon type="error" description="กรุณาเลือกอย่างน้อย 1 โครงการ"></Message>
            </Row>
          )} */}

            <IconButton
              appearance="ghost"
              icon={<Icon icon={data.icon || 'save'} className="bt-gost-icon-radius" />}
              style={{ float: 'right', marginBottom: 20, marginTop: 10 }}
              disabled={isSubmitLoading || setting}
              onClick={() => {
                onSubmit(statusBox)
              }}
            >
              {schema.buttonFilterStatus
                ? `${data.preText || ''}${
                    schema.buttonFilterStatus.find((e) => e.status == statusBox)?.buttonText ||
                    data?.buttonText ||
                    ''
                  }${data.postText || ''}`
                : data?.buttonText || ''}
            </IconButton>
          </Row>
        )}
      </>
    )
  }

  const getData = () => {
    return schema.values?.filter((v, i) => {
      const start = displayLength * (page - 1)
      const end = start + displayLength
      return i >= start && i < end
    })
  }

  const renderButtonBadge = (data, index) => {
    let buttonBadge
    buttonBadge = (
      <Badge
        maxCount={9999}
        content={data.countStatus}
        style={{ marginRight: 15, fontWeight: 800, marginTop: 15 }}
        key={index}
      >
        <Button
          disabled={statusBox == data.status || setting}
          style={{
            color: '#000000',
            backgroundColor: data.colorStatus,
            fontWeight: 800,
          }}
          onClick={() => {
            setStatusBox(data.status)
            handleSearchByStatusBox(data.status)
          }}
        >
          {data.buttonText}
        </Button>
      </Badge>
    )

    return buttonBadge
  }

  const renderStatusButton = (values) => {
    var total = 0
    let data1 = values?.map((data, index) => {
      if (data.status) {
        total = total + data.countStatus
        return renderButtonBadge(data, index)
      }
    })

    let result = (
      <>
        {data1}
        {values?.length > 0 &&
          renderButtonBadge(
            {
              countStatus: total,
              colorStatus: '#EEEEEE',
              status: '',
              buttonText: 'ทั้งหมด',
            },
            'total'
          )}
      </>
    )

    return result
  }

  return (
    <>
      <Panel
        header={schema.header}
        bordered
        collapsible
        defaultExpanded
        shaded
        style={{ marginTop: 15 }}
      >
        {searchEnable && typeof onReload == 'function' && (
          <Grid fluid style={{ marginBottom: 15 }}>
            <Row gutter={16}>
              <Col lg={5} md={8} sm={24} xs={24} style={{ marginTop: 10 }}>
                <ControlLabel>รหัสโครงการ</ControlLabel>
                <Input
                  name={'projectcode'}
                  value={inputValueCode}
                  placeholder="ระบุรหัสโครงการ"
                  onChange={(value) => {
                    setInputValueCode(value)
                  }}
                  disabled={setting}
                />
              </Col>
              <Col lg={5} md={8} sm={24} xs={24} style={{ marginTop: 10 }}>
                <ControlLabel>ชื่อโครงการ</ControlLabel>
                <Input
                  name={'projectname'}
                  value={inputValueName}
                  placeholder="ระบุชื่อโครงการ"
                  onChange={(value) => {
                    setInputValueName(value)
                  }}
                  disabled={setting}
                />
              </Col>
              {projectTypeSearch && (
                <Col lg={5} md={8} sm={24} xs={24} style={{ marginTop: 10 }}>
                  <ControlLabel>{projectTypeSearch.label}</ControlLabel>

                  <SelectPicker
                    data={projectTypeSearch.options}
                    value={projectType}
                    style={{ width: '100%' }}
                    searchable={false}
                    placeholder={projectTypeSearch.hint || `เลือก${projectTypeSearch.label || ''}`}
                    onChange={(value) => {
                      setProjectType(value)
                    }}
                    disabled={setting}
                  />
                </Col>
              )}
              {departmentSearch && (
                <Col lg={5} md={8} sm={24} xs={24} style={{ marginTop: 10 }}>
                  <ControlLabel>{departmentSearch.label}</ControlLabel>

                  <SelectPicker
                    data={departmentSearch.options}
                    value={department}
                    style={{ width: '100%' }}
                    searchable={false}
                    placeholder={departmentSearch.hint || `เลือก ${departmentSearch.label || ''}`}
                    onChange={(value) => {
                      setDepartment(value)
                    }}
                    disabled={setting}
                  />
                </Col>
              )}

              {reviewTypeSearch && (
                <Col lg={5} md={8} sm={24} xs={24} style={{ marginTop: 10 }}>
                  <ControlLabel>{reviewTypeSearch.label}</ControlLabel>

                  <SelectPicker
                    data={reviewTypeSearch.options}
                    value={inputValueReviewType}
                    style={{ width: '100%' }}
                    searchable={false}
                    placeholder={reviewTypeSearch.hint}
                    onChange={(value) => {
                      setInputValueReviewType(value)
                    }}
                    disabled={setting}
                  />
                </Col>
              )}

              <Col lg={5} md={12} sm={24} xs={24} style={{ marginTop: 10 }}>
                <div>
                  <br />
                  <IconButton
                    appearance="ghost"
                    size="md"
                    icon={<Icon appearance="ghost" icon="search" className="bt-gost-icon-radius" />}
                    style={{
                      marginBottom: '10px',
                      marginRight: '10px',
                      width: '45%',
                      // height: '35px',
                    }}
                    onClick={handleSearchProject}
                    disabled={setting}
                  >
                    ค้นหา
                  </IconButton>
                  <IconButton
                    appearance="ghost"
                    className="rs-btn-ghost-edit"
                    size="md"
                    icon={
                      <Icon
                        appearance="ghost"
                        icon="close-circle"
                        className="bt-gost-icon-radius-edit"
                      />
                    }
                    style={{ marginBottom: '10px', width: '45%' }}
                    onClick={handleCancelSearchProject}
                    disabled={setting}
                  >
                    ยกเลิก
                  </IconButton>
                </div>
              </Col>
            </Row>
            {/* <Row> */}
            <div className="status-button-search">
              {schema.buttonFilterStatus && renderStatusButton(schema.buttonFilterStatus)}
            </div>
            {/* </Row> */}
          </Grid>
        )}

        {(pagination && typeof onReload !== 'function' ? getData() : schema.values || []).length <
        1 ? (
          <div style={{ marginBottom: 10 }}>
            <b>{`*** ไม่พบข้อมูลในระบบ ***`}</b>
            {multi?.showIsNodata && multiButton()}
          </div>
        ) : (
          <>
            <Table
              wordWrap
              // height={400}
              autoHeight
              headerHeight={fs <= 15 ? undefined : fs < 16 ? 70 : fs <= 18 ? 75 : 80}
              loading={loading}
              // autoHeight={schema.values?.length <= 5}
              data={pagination && typeof onReload !== 'function' ? getData() : schema.values || []}
            >
              <Column width={(fs || 1) < 18 ? 120 : 140}>
                <HeaderCell style={styleHeaderCell}>
                  <span>{schema.projectCodeText}</span>
                </HeaderCell>
                <Cell dataKey="projectCode" />
              </Column>

              {subName?.enable ? (
                <Column width={400} minWidth={400} flexGrow={1}>
                  <HeaderCell>
                    <span>{schema.projectNameText}</span>
                  </HeaderCell>

                  <SubnameCell dataKey="projectName" />
                </Column>
              ) : (
                <Column width={400} minWidth={400} flexGrow={1}>
                  <HeaderCell>
                    <span>{schema.projectNameText}</span>
                  </HeaderCell>

                  <Cell dataKey="projectName" />
                </Column>
              )}

              {schema.projectReviewTypeText && (
                <Column width={160} align="center">
                  <HeaderCell>
                    <span>{schema.projectReviewTypeText}</span>
                  </HeaderCell>
                  <Cell dataKey="projectReviewTypeLabel" />
                </Column>
              )}

              {!hideProjectType && (
                <Column //width={resizeProjectTypeField ? 220 : 200}
                  width={(fs || 1) < 18 ? 150 : 180}
                >
                  <HeaderCell>
                    <span>{schema.projectTypeText}</span>
                  </HeaderCell>
                  <ImageCell dataKey="projectType" />
                </Column>
              )}

              <Column width={180} align="right">
                <HeaderCell>
                  <span>{schema.projectBudgetText}</span>
                </HeaderCell>
                <Cell>
                  {(rowData) => {
                    return budgetFormat(rowData.projectBudget)
                  }}
                </Cell>
              </Column>
              {multi?.enable && !multi?.disableSelect && (
                <Column width={90} align="center" fixed="right">
                  <HeaderCell>
                    <span>{schema.selectText || 'เลือก'}</span>
                  </HeaderCell>

                  <Cell>
                    {(rowData) => {
                      let isCheck = selectList.some((el) => el.id === rowData.id)
                      return (
                        <Checkbox
                          checked={isCheck}
                          inline
                          disabled={rowData.multiDisabled || setting}
                          onChange={(_, check) => {
                            let listed = [...selectList]

                            if (check) {
                              listed.push(rowData)
                              setSelectList(listed)
                              setIsError(false)
                            } else {
                              let index = listed.findIndex((item) => item.id === rowData.id)
                              if (index >= 0) {
                                listed.splice(index, 1)
                                setSelectList(listed)
                              }
                            }
                          }}
                        />
                      )
                    }}
                  </Cell>
                </Column>
              )}
              {single?.enable && (
                <Column
                  width={single.width ? single.width : single.hideText ? 70 : 130}
                  align="center"
                  fixed="right"
                >
                  <HeaderCell></HeaderCell>

                  <Cell>
                    {(rowData) => {
                      let iconColor = single.color
                      let icon = 'save'

                      switch (rowData.projectStatus) {
                        case 1:
                          iconColor = ''
                          icon = 'check-circle'
                          break
                        case 2:
                          iconColor = '#f8bb6a'
                          icon = 'info'
                          break
                      }

                      return (
                        <>
                          <TooltipButton
                            icon={single.iconByStatus ? icon : single.icon || 'eye'}
                            iconStyle={{ color: single.iconByStatus ? iconColor : single.color }}
                            tooltip={single.buttonText || ''}
                            onClick={(e) => onSingleSubmit(rowData, statusBox)}
                            isStart={true}
                            disabled={setting}
                            //isDeleteBtn={single.deleteBtn}
                          >
                            {single.hideText ? undefined : <>{single.buttonText}</>}
                          </TooltipButton>
                        </>
                      )
                    }}
                  </Cell>
                </Column>
              )}
              {enableView && (
                <Column width={onRemove ? 200 : 150} align="center" fixed="right">
                  <HeaderCell align="center"></HeaderCell>

                  <Cell>
                    {(rowData) => {
                      return (
                        <>
                          <TooltipButton
                            style={{ marginTop: 5 }}
                            icon="eye"
                            tooltip={`แสดง`}
                            onClick={(e) => onView(rowData.id)}
                            disabled={setting}
                          >
                            แสดง
                          </TooltipButton>
                          {onRemove && (
                            <TooltipButton
                              style={{ marginLeft: 10, marginTop: 5 }}
                              icon="trash-o"
                              tooltip={`ลบ`}
                              onClick={(e) => {
                                setDeleteObj(rowData)
                                setIsShowConfirm(true)
                              }}
                              disabled={setting}
                            >
                              ลบ
                            </TooltipButton>
                          )}
                        </>
                      )
                    }}
                  </Cell>
                </Column>
              )}
            </Table>
            {pagination && (
              <TablePagination
                lengthMenu={lengthMenu || defaultLengthMenu}
                activePage={page || defaultPage}
                renderLengthMenu={(lengthMenu) => {
                  return (
                    <>
                      {lengthMenu}
                      {`รายการ/หน้า`}
                    </>
                  )
                }}
                renderTotal={(total) => {
                  return <>{` ทั้งหมด ${total} รายการ`}</>
                }}
                displayLength={displayLength || 5}
                total={schema.totalSize}
                onChangePage={handleChangePage}
                onChangeLength={handleChangeLength}
              />
            )}

            {schema?.message && (
              <Row>
                <Message showIcon type={schema.message.type} description={schema.message.message} />
              </Row>
            )}

            {multiButton()}
            <SubmitButton data={submit} disabled={setting} />
          </>
        )}

        {props.children && <Row>{props.children}</Row>}
      </Panel>

      <ConfirmWidget
        title={`ยืนยันการลบรายการ`}
        show={isShowConfirm}
        detail={
          <>
            <label>ยืนยันการลบ </label>
            <>
              {deleteObj?.projectName ? (
                <>
                  <label style={{ fontWeight: 'bold' }}> โครงการ : </label>{' '}
                  <label>{deleteObj.projectName}</label>{' '}
                </>
              ) : (
                ''
              )}
            </>
            {/* `ยืนยันการลบ ${
          deleteObj?.projectName ? schema.projectNameText + ' : ' + deleteObj.projectName : ''
        }` */}
          </>
        }
        onCancle={() => {
          setIsShowConfirm(false)
          setDeleteObj({})
        }}
        onConfirm={() => {
          onRemove(deleteObj)
          let total = schema.values.length
          let newPage = Math.ceil(total / displayLength)
          if (newPage > 0 && newPage < page) {
            setPage(newPage)
          }
          setIsShowConfirm(false)
        }}
      />
    </>
  )
}
